<!-- app/components/Header/Content.vue -->
<template>
  <div ref="headerWrapper" :class="['w-full relative', classesHeader]">
    <div class="absolute left-0 top-0 w-0 h-0 overflow-hidden invisible pointer-events-none">
      <div ref="phantomMenu" aria-hidden="true"
           class="absolute left-0 opacity-0 pointer-events-none flex flex-row gap-4 z-[-1]">
        <HeaderMainMenu :variant="variant" orientation="horizontal" />
      </div>
    </div>

    <header class="flex items-center justify-between px-4 w-full h-full">
      <div ref="leftArea" class="shrink-0">
        <AppLogo :variant="variant === 'primaria' ? 'principal' : 'secundaria'" />
      </div>

      <nav v-show="!isMobileMode" class="flex-1 flex justify-self-start px-4">
        <HeaderMainMenu :variant="variant" orientation="horizontal" />
      </nav>

      <div ref="rightArea" class="flex shrink-0 items-center gap-4">
        <ClientOnly>
          <HeaderRight :variant="variant" :showUserMenu="true" />
          <UButton v-show="isMobileMode" icon="ph:list-bold" variant="ghost" :class="textClass" :ui="{leadingIcon: 'size-7'}"
             @click="uiStore.openSlideoverMainMenu = true"/>
        </ClientOnly>
      </div>

    </header>
  </div>
</template>

<script setup lang="ts">
import { computed, ref, onMounted, onBeforeUnmount, watch } from 'vue'

// ─── Props ────────────────────────────────────────────────────────────────────

const props = defineProps<{
  variant: 'primaria' | 'secundaria'
}>()

const uiStore = useUiStore() // Instanciamos a store

// ─── Estado interno ───────────────────────────────────────────────────────────

const isMobileMode = ref(false)

// ─── Refs de DOM para medir largura ───────────────────────────────────────────
const headerWrapper = ref<HTMLElement | null>(null)
const phantomMenu = ref<HTMLElement | null>(null)
const leftArea = ref<HTMLElement | null>(null)
const rightArea = ref<HTMLElement | null>(null)

// ─── Lógica de layout adaptativo ─────────────────────────────────────────────

/**
 * Compara a largura disponível com o espaço necessário para o menu horizontal.
 * Se não couber, ativa o modo mobile (hamburguer + slideover).
 */
const checkMenuFit = () => {
  if (!headerWrapper.value || !phantomMenu.value || !leftArea.value || !rightArea.value) return

  const availableWidth = headerWrapper.value.clientWidth
  const logoWidth = leftArea.value.clientWidth
  const rightPanelWidth = rightArea.value.clientWidth
  const requiredMenuWidth = phantomMenu.value.scrollWidth
  const marginDeSeguranca = 64

  const requiredTotalWidth = logoWidth + requiredMenuWidth + rightPanelWidth + marginDeSeguranca

  isMobileMode.value = availableWidth < requiredTotalWidth

  // Fecha o slideover global automaticamente ao voltar para desktop
  if (!isMobileMode.value) {
    uiStore.openSlideoverMainMenu = false
  }
}

let resizeObserver: ResizeObserver | null = null

onMounted(() => {
  resizeObserver = new ResizeObserver(checkMenuFit)
  if (headerWrapper.value) {
    resizeObserver.observe(headerWrapper.value)
  }
})

onBeforeUnmount(() => {
  resizeObserver?.disconnect()
})


// ─── Classes computadas ───────────────────────────────────────────────────────

const isPrimaria = computed(() => props.variant === 'primaria')

const textClass = computed(() =>
  isPrimaria.value ? 'text-white' : 'text-gray-700'
)

const classesHeader = computed(() =>
  isPrimaria.value
    ? 'border-none bg-gradient-to-r from-[#039B75] to-[#01365A] shadow-lg py-2'
    : 'bg-white shadow-xl border-b border-gray-200 py-2'
)
</script>